import { sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';
import { getAnchorElementFromEvent } from '@noths/polaris-client-utils';

import type { TrackingContext } from 'src/types/TrackingContext';

export const trackLinkClick = (
  e: React.MouseEvent<HTMLElement>,
  { trackingContentType, trackingPosition, trackingTitle }: TrackingContext,
) => {
  const element = getAnchorElementFromEvent(e);

  if (element) {
    const { href, text } = element;
    sendGALinkClickEvent(e, {
      event: 'custom_event',
      event_action: 'CTA click',
      event_category: `${trackingPosition} | ${trackingContentType}`,
      event_label: `${trackingPosition} | ${trackingTitle} | cta`.toLowerCase(),
      event_name: 'select_content',
      event_details: 'cta click',
      content_position: `${trackingPosition}`,
      content_type: `${trackingContentType}|${trackingTitle}`.toLowerCase(),
      destination_URL: href,
      item_id: text.toLowerCase(),
    });
  }
};
